var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-motion"},[_c('div',{staticClass:"text-container"},[_c('div',{ref:"textAnimation",staticClass:"text-animation"},_vm._l((_vm.currentText.split('')),function(char,index){return _c('span',{key:index,ref:`char-${index}`,refInFor:true,staticClass:"text-char"},[_vm._v(" "+_vm._s(char)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }